import { type GridInputSelectionModel, type GridCallbackDetails, type GridSelectionModel } from '@mui/x-data-grid-pro';

// Строка таблицы «Квитанции предыдущих периодов» жителя.
// Ровно то, что нужно UI: id абонента (для selectionModel и body запроса), номер помещения и площадь.
// Столбца «Собственник»/name здесь нет намеренно — упрощённый под данные жителя вариант экрана председателя.
export interface AppartmentPastInvoiceRow {
  id: number;
  flat: string;
  square: number;
}

export interface AppartmentPastInvoicesViewModel {
  abonents: AppartmentPastInvoiceRow[];
  selectionModel: GridInputSelectionModel;
  date: Date;
  isLoading: boolean;
  abonentsIsNotSelected: boolean;

  onSelectionModelChange: (selectionModel: GridSelectionModel, details: GridCallbackDetails) => void;
  downloadInvoices: () => Promise<void>;
}

export const AppartmentPastInvoicesViewModelIdentifier = Symbol.for('AppartmentPastInvoicesViewModel');
